import { Outlet, Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function ReportingLayout() {
  const location = useLocation();

  const tabs = [
    { name: "Payable & Revenue", path: "/super-admin/reports-v2/revenue" },
    { name: "Pricing Matrix", path: "/super-admin/reports-v2/pricing-matrix" },
    { name: "Utilization", path: "/super-admin/reports-v2/utilization" },
  ];

  return (
    <div className="flex flex-col h-full">
      <div className="border-b bg-muted/30 px-6 py-2">
        <nav className="flex space-x-4">
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path;
            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={cn(
                  "px-3 py-2 text-sm font-medium rounded-md transition-colors",
                  isActive 
                    ? "bg-primary text-primary-foreground" 
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}
              >
                {tab.name}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
